import styled from 'styled-components';
import media from 'styled-media-query';

export const StyledBurger = styled.button`
  position: absolute;
  right: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  
  &:focus {
    outline: none;
  }
  
  div {
    width: 2rem;
    height: 0.25rem;
    background: var(--texts);
    border-radius: 10px;     
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ status }) => status ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${({ status }) => status ? '0' : '1'};
      transform: ${({ status }) => status ? 'translateX(20px)' : 'translateX(0)'};
    }

    :nth-child(3) {
      transform: ${({ status }) => status ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
  

  ${media.greaterThan("large")`
      display: none;
  `}
`;